import { LineItemsStateProvider } from "../../../refund/hooks/use-line-items-state-context";
import { RefundLineItemsProvider } from "../../../refund/hooks/use-refund-line-items-context";
import { ReturnRequestButton } from "../return-request-button/return-request-button";

export default function NavActions() {
  return (
    <LineItemsStateProvider>
      <div className={"flex flex-row items-center gap-2"}>
        <RefundLineItemsProvider>
          <ReturnRequestButton />
        </RefundLineItemsProvider>
      </div>
    </LineItemsStateProvider>
  );
}
